import { useEffect } from 'react';
import { initializeFacebookSDK, checkFacebookLoginStatus, getFacebookUserData } from './facebookSDK';
import userStateManager from '../AppWriteOAuth/UserStateManager';

const FacebookAuthListener = () => {
  useEffect(() => {
    // Facebook SDK-ის ინიციალიზაცია და სესიის შემოწმება გვერდის ჩატვირთვისას
    const initAndCheckFacebookAuth = async () => {
      try {
        // 1. ჯერ ვაინიციალიზებთ Facebook SDK-ს
        await initializeFacebookSDK();
        
        // 2. შევამოწმოთ არის თუ არა localStorage-ში Facebook მომხმარებელი
        const currentUser = userStateManager.getCurrentUser();
        
        if (currentUser && currentUser.user_type === 'clientOfFacebook') {
          // 3. შევამოწმოთ Facebook-ის სესია
          const loginStatus = await checkFacebookLoginStatus();
          
          if (!loginStatus.isLoggedIn) {
            // თუ Facebook-ზე სესია აღარ არსებობს, გავასუფთაოთ ლოკალური მონაცემები
            console.log('⚠️ Facebook session expired, clearing local data');
            await userStateManager.clearUser();
          } else {
            // თუ სესია არსებობს, განვაახლოთ მომხმარებლის მონაცემები
            const fbUser = await getFacebookUserData();
            
            if (fbUser) {
              // განვაახლოთ მონაცემები თუ რამე შეიცვალა
              const updatedUserData = {
                external_Id: fbUser.id,
                first_name: fbUser.name.split(' ')[0] || fbUser.name,
                profile_img: fbUser.picture?.data?.url || currentUser.profile_img,
                user_type: 'clientOfFacebook' as const,
                email: fbUser.email || currentUser.email,
              };
              
              userStateManager.setUser(updatedUserData);
              console.log('✅ Facebook session validated and user data updated');
            }
          }
        }
      } catch (error) {
        console.error('Facebook auth check failed:', error);
      }
    };

    // ინიციალიზაცია
    initAndCheckFacebookAuth();
  }, []);

  // კომპონენტი არ აბრუნებს UI ელემენტებს
  return null;
};

export default FacebookAuthListener;